import React from 'react';
// components
import { Checkbox } from '../../../components/table/ui';
// helpers/constants
import * as G from '../../../helpers';
// ui
import { Flex, MainActionButton } from '../../../ui';
//////////////////////////////////////////////////

const borderGrayColor = G.getTheme('colors.borderGray');

const btnStyles = {
  height: 'auto',
  fontWeight: 600,
  borderRadius: 10,
  border: '1px solid',
  borderColor: borderGrayColor,
  color: G.getTheme('colors.dark.mainDark'),
};

export const MarkComponent = ({
  check,
  selectAll,
  actionRead,
  handleDeleteAllNotifications,
  handleDeleteSelectedNotifications,
}) => (
  <Flex p={15} borderBottom='1px solid' borderColor={borderGrayColor} justifyContent='space-between'>
    <Checkbox type='checkbox' mainColors={true} checked={Boolean(check)} onClick={() => selectAll('all')} />
    <Flex gap={10}>
      <MainActionButton {...btnStyles} onClick={() => actionRead(true)}>
        {G.getWindowLocale('actions:mark-as-read', 'Mark as read')}
      </MainActionButton>
      <MainActionButton {...btnStyles} onClick={() => actionRead(false)}>
        {G.getWindowLocale('actions:mark-as-unread', 'Mark as unread')}
      </MainActionButton>
      <MainActionButton {...btnStyles} onClick={handleDeleteSelectedNotifications}>
        {G.getWindowLocale('actions:delete-selected', 'Delete Selected')}
      </MainActionButton>
      <MainActionButton {...btnStyles} ml={15} onClick={handleDeleteAllNotifications}>
        {G.getWindowLocale('actions:delete-all', 'Delete All')}
      </MainActionButton>
    </Flex>
  </Flex>
);
